var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProgressIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#E6A500",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M12 6V3m0 18v-2m7-7h2M3 12h3m11.657-5.657.707-.707M5.636 18.364 7.05 16.95m9.9 0 1.414 1.414M5.636 5.636l2.121 2.121"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgProgressIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/progress-icon.d657553c86698356b2fcdd796b4cff28.svg";